import(/* webpackMode: "eager" */ "/home/cvb255/00/apps/binoth/book/client/app/global-error.tsx");
